import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    firstName,
    lastName,
    email,
    workPhoneNumber,
    code,
    ssn,
    subCompany,
    location,
    job,
    rate,
    status,
    typeCode,
  },
} = checkout;
export default Yup.object().shape({
  [workPhoneNumber.name]: Yup.string()
    .required(workPhoneNumber.errorMsg)
    .test("phone-validate", "Phone number is not valid", (value) => {
      if (typeof value === "string" && parsePhoneNumber(value)) {
        return isValidPhoneNumber(parsePhoneNumber(value).number);
      }
      return false;
    }),
  [firstName.name]: Yup.string().required(firstName.errorMsg),
  [lastName.name]: Yup.string().required(lastName.errorMsg),
  [email.name]: Yup.string().email().required(email.errorMsg),
  [code.name]: Yup.string().required(code.errorMsg),
  [ssn.name]: Yup.string().required(ssn.errorMsg),
  [subCompany.name]: Yup.string().required(subCompany.errorMsg),
  [location.name]: Yup.string().required(location.errorMsg),
  [job.name]: Yup.string().required(job.errorMsg),
  [rate.name]: Yup.string().required(rate.errorMsg),
  [status.name]: Yup.string().required(status.errorMsg),
  [typeCode.name]: Yup.string().required(typeCode.errorMsg),
});
